import { RestaurantDetailLocation } from '@/features/restaurants/restaurant-detail/restaurant-detail-location/restaurant-detail-location'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'

export const RestaurantDetailLocationSection = () => {
    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.LOCATION}
            title="restaurants.detail.location.title"
            description="restaurants.detail.location.description"
            className="mb-14"
        >
            <RestaurantDetailLocation styleType="full" />
        </RestaurantDetailSection>
    )
}
